// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-header-tab__menu .x-header-tab__badge {\n  margin-right: 21px;\n}\n.x-header-tab__menu .x-header-tab__badge .ant-badge-dot {\n  -webkit-box-shadow: 0 0px;\n          box-shadow: 0 0px;\n}\n", ""]);
// Exports
module.exports = exports;
